var helper = require('./helper');

$('.js-send-email-to-guardians-of-block').on('change', function(e) {

	var blockId = $(this).val();

	if(blockId > 0){
		window.location.href = helper.getOrigin() + "/blocks/" + blockId + "/emails/guardians/create";
	}
});